import React, {useEffect, useState, useRef, useCallback} from 'react';
import {
    Box,
    Button,
    useToast,
    VStack,
    Text,
    useDisclosure,
    Stack,
    Heading,
    Flex,
    Container,
    useColorModeValue,
    Icon,
    useBreakpointValue,
    InputGroup,
    Tooltip,
    Image,
    InputLeftAddon,
    InputRightAddon,
    Input,
    HStack,
    Badge,
    Link,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    SimpleGrid,
    Center,
} from '@chakra-ui/react';
import axios from 'axios';
import DocumentGrid from './DocumentGrid';
import {createThumbnail} from '../../utils/pdf-page-helpers';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../redux/AuthProvider';
import { useDispatch, useSelector } from 'react-redux';
import {
    addDocument,
    addVideo,
    setOneVideo,
    removeDocument,
    setCurrentChatInput,
    setDocuments,
    setIsPricingModalOpen,
    setIsUploadLoading,
    setScanError,
    setScanEstimatedSeconds,
    setScanFileID,
    setVideos,
    setDocumentsGeneration,
    setAudiobooks,
    setScanType,
    addAudiobook,
    setOutlineInAudiobook,
    addAudioInAudiobook,
    addDocumentGenerationNative,
    addDocumentGeneration, setDocumentsGenerationNative
} from '../../redux/reducers';
import { addDocumentInStorage, getDocumentsInStorage } from '../../utils/local-storage-helpers';
import {influencerMap, SERVER_IP, SERVER_IP_VIDEO} from "../../utils/constants";
import {useDropzone} from "react-dropzone";
import { motion } from 'framer-motion';
import SignUpScreen1 from "../../components/Modals/SignUp/SignUpScreen1";
import SignInScreen1 from "../../components/Modals/SignIn/SignInScreen1";
import LargeWithNewsletter from "../../components/Reuseable/LargeWithNewsletter";
import LoadingBar from "./LoadingBar";
import FullScreenTemplateHomePage from "../../templates/FullScreenTemplateHomePage";
import {
    FcAddImage,
    FcDocument, FcLock, FcMultipleInputs, FcQuestions, FcReading, FcSportsMode, FcViewDetails,
} from 'react-icons/fc'
import ReactPlayer from "react-player/lazy";
import LazyLoad from 'react-lazyload';
import lightTheme from "../../utils/styles";
import {fetchAudiobooks, fetchDocuments, fetchVideos} from "../../utils/redux-helpers";
import ScanModal1 from "../../components/Modals/Scans/ScanModal1";
import ScanModalIntro1 from "../../components/Modals/Scans/ScanModalIntro1";
import WithSpeechBubbles from "./WithSpeechBubbles";
import PricingScreen from "../../components/Modals/Payments/PricingScreen";
import '../../fonts.css';
import {useTranslation} from "react-i18next";
import LogoCarousel2 from "../../components/Reuseable/LogoCarousel2";
import URLInput from "./URLInput";
import DocumentGridVideos from "./DocumentGridVideos";
import DocumentGridGeneration from "./DocumentGridGeneration";
import DocumentGridGenerationEmpty from "./DocumentGridGenerationEmpty";
import DocumentGridVideosEmpty from "./DocumentGridVideosEmpty";
import TwoColumnLayout from "./TwoColumnLayout";
import BigTestimonial from "./BigTestimonial";
import DocumentGridEmpty from "./DocumentGridEmpty";
import {createMultidocSessionNativeChat, fetchMultidocsNative, initializeMultidoc} from "../../utils/multi-doc-helpers";
import {fetchMultidocs} from "../../utils/multi-doc-helpers";
import {useServerIP} from "../../redux/ServerIPContext";
import DocumentGridAudiobooks from "./DocumentGridAudiobooks";
import DocumentGridAudiobooksEmpty from "./DocumentGridAudiobooksEmpty";
import {createAudiobook} from "../../utils/audiobook-helpers";
import {
  initiateMultipartUpload,
     uploadMultipartParts,
  completeMultipartUpload
} from '../../utils/multipartUpload';
import {
    initiateMultipartUploadPDF,
    uploadMultipartPartsPDF,
    completeMultipartUploadPDF
} from '../../utils/multipartUploadPDF';
import {DocumentGridMembers} from "./DocumentGridMembers";
import DocumentGridMembersEmpty from "./DocumentGridMembersEmpty";
import {FiEdit3, FiFileText, FiSearch} from "react-icons/fi";
import FAQ2 from "../Payments/FAQ2";
import {failedPDFNotification} from "../../utils/api";
import {
    completeMultipartUploadConversion,
    initiateMultipartUploadConversion,
    uploadMultipartPartsConversion
} from "../../utils/multipartUploadConversion";
import {getFileExtension} from "../../utils/socketRooms";

// import localForage from 'localforage';
//
// // Configure localForage to use your application's name and store name
// localForage.config({
//     name: 'MyApp',
//     storeName: 'thumbnails', // name of the datastore
// });
const MotionBox = motion(Box);

// next up. Add audiobooks here from top to bottom
const NewUnifiedHomePage = () => {
    const { serverIPs, setServerIPs, isDev } = useServerIP();
    const {t} = useTranslation();
    const featuresRef = useRef(null);
    const testimonialsRef = useRef(null);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const fileInput = useRef();
    const fileInputAudiobook = useRef();
    const { isOpen: isOpenSignUpScreen1, onOpen: onOpenSignUpScreen1, onClose: onCloseSignUpScreen1 } = useDisclosure();
    const { isOpen: isOpenSignInScreen1, onOpen: onOpenSignInScreen1, onClose: onCloseSignInScreen1 } = useDisclosure();
    const { isOpen: isOpenScanModal1, onOpen: onOpenScanModal1, onClose: onCloseScanModal1 } = useDisclosure();
    const { isOpen: isOpenScanModalIntro1, onOpen: onOpenScanModalIntro1, onClose: onCloseScanModalIntro1 } = useDisclosure();
    const { isOpen: isOpenPricingScreen, onOpen: onOpenPricingScreen, onClose: onClosePricingScreen } = useDisclosure();
    const isUploadLoading = useSelector(state => state.settings.isUploadLoading);
    const [uploadProgress, setUploadProgress] = useState(0);
    const auth = useAuth();
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm';
    const fileInputVideo = useRef();

    const navigateToTestimonials = () => {
        if (testimonialsRef.current) {
            const offsetTop = testimonialsRef.current.getBoundingClientRect().top + window.pageYOffset;
            const offset = 110; // The amount of pixels you want to stop above the element
            window.scrollTo({ top: offsetTop - offset, behavior: 'smooth' });
        }
    }

    const navigateToFeatures = () => {
        if (featuresRef.current) {
            const offsetTop = featuresRef.current.getBoundingClientRect().top + window.pageYOffset;
            const offset = 50; // The amount of pixels you want to stop above the element
            window.scrollTo({ top: offsetTop - offset, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const hash = window.location.hash.substring(1);
        if (hash) {
            if (hash === 'features' && featuresRef.current) {
                const offsetTop = featuresRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: offsetTop - 160, behavior: 'smooth' });
            } else if (hash === 'testimonials' && testimonialsRef.current) {
                const offsetTop = testimonialsRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: offsetTop - 140, behavior: 'smooth' });
            }
        }
    }, []);

    // WTFFFFFFFFFFFFFFFFFFFF
    useEffect(() => {
        const tab = searchParams.get('tab');
        if (tab === 'videos') {
            setTabIndex(2); // Set Videos tab active
        } else if (tab === 'multidoc') {
            setTabIndex(1); // Set Multidoc tab active
        } else if (tab === 'images') {
            setTabIndex(3); // Set Images tab active
        } else if (tab === 'members') {
            setTabIndex(4); // Set Members tab active
        } else if (tab === 'bigquery') {
            setTabIndex(5); // Set BigQuery tab active
        }
        else {
            setTabIndex(0); // Default to PDFs tab
        }
    }, [searchParams]);

    const handleTabChange = (index) => {
        if (index === 0) {
            setSearchParams({ tab: 'pdfs' });
        } else if (index === 1) {
            setSearchParams({ tab: 'multidoc' });
        } else if (index === 2) {
            setSearchParams({ tab: 'videos' });
        } else if (index === 3) {
            setSearchParams({ tab: 'images' });
        } else if (index === 4) {
            setSearchParams({ tab: 'members' });
        } else if (index === 5) {
            setSearchParams({ tab: 'bigquery' });
        }
        // setSearchParams({ tab: index === 0 ? 'pdfs' : 'videos' }); // Update URL with query parameter
    };

    const onDropVideo = useCallback((acceptedFiles) => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
            toast({
                title: t("(Free Plan) Video Upload Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            return;
        }

        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload video/audio files",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
            return;
        }
        
        if (acceptedFiles.length > 0) {
            handleMP4Upload({target: {files: acceptedFiles}}).then(r => {
                navigate('/?tab=videos');
            });
        }
    }, []);
    const {
        getRootProps: getRootPropsVideo,
        getInputProps: getInputPropsVideo,
        isDragActive: isDragActiveVideo
    } = useDropzone({
        onDrop: onDropVideo,
        accept: {
            'video/*': [],
            'audio/*': []
        },
        multiple: false,
        onDropRejected: (rejectedFiles) => {
            toast({
                title: "Please upload 1 video/audio file at a time",
                status: "error",
                duration: 9500,
                isClosable: true,
                position: "top",
            });
        },
    });

    const onDropAudiobook = useCallback((acceptedFiles) => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
            toast({
                title: t("(Free Plan) Upload Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            return;
        }

        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload images",
                description: "analyze 1 or multiple images efficiently",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
            return;
        }
        
        if (acceptedFiles.length > 0) {
            handleFileUploadImage({target: {files: acceptedFiles}}).then(r => {
                navigate('/?tab=images');
            });
        }
    }, []);
    const {
        getRootProps: getRootPropsAudiobook,
        getInputProps: getInputPropsAudiobook,
        isDragActive: isDragActiveAudiobook
    } = useDropzone({
        onDrop: onDropAudiobook, // Correctly assign the function
        accept: {
            'image/*': []
        },
        multiple: true,
        onDropRejected: (rejectedFiles) => {
            toast({
                title: "This tab specializes in images",
                description: "Use the 'Single-Upload' or 'Multi-Upload' tab for other file types.",
                status: "error",
                duration: 9500,
                isClosable: true,
                position: "top",
            });
        },
    });

    const onDrop = useCallback((acceptedFiles) => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
            toast({
                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            return;
        }

        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            handleFileUpload({target: {files: [file]}}, false).then(r =>{
                navigate('/?tab=pdfs');
            });
        }
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'application/pdf',
        multiple: false,
    });

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const videoProgress = async (progress_key) => {
        while (true) {
            try {
                console.log("CALLING GENERAL_PROGRESS with key:", progress_key);
                const response = await axios.post(serverIPs.SERVER_IP + "/general_progress", {
                    key: progress_key
                });
                console.log("GENERAL_PROGRESS response:", response);
                // Resolve only if the message is not one of the waiting messages.
                // if (response.data.message !== "Starting to transcribe video" &&
                //     response.data.message !== "key not found") {
                //     return response.data.message;
                // } else if (response.data.message === "Finished transcribing video") {
                //     return response.data.message;
                // }
                if (response.data.message === "Finished transcribing video") {
                    return response.data.message;
                }
                else if (response.data.message === 400) {
                    console.log("VIDEO TRANSCRIPTION FAILED");
                    // Video transcription failed, return special code to trigger Gemini route
                    return "400";
                }
            } catch (error) {
                console.error("Error in general_progress", error);
            }
            // Wait for 5 seconds before retrying.
            await sleep(5000);
        }
    };

    const handleMP4Upload = async (event) => {
        dispatch(setIsUploadLoading(true));
        const file = event.target.files[0];
        // if (!file || file.type !== "video/mp4") return;

        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload mp4/mp3 files",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
            dispatch(setIsUploadLoading(false));
            return;
        }

        // const formData = new FormData();
        // formData.append("data_type", "file");
        // formData.append("user_id", localStorage.getItem("userID"));
        try {
            // console.log("/videos/get_file_upload_url payload", {
            //     user_id: formData.get("user_id"),
            //     filename: file.name,
            // })
            // const firstResponse = await axios.post(serverIPs.SERVER_IP + '/videos/get_file_upload_url', {
            //     user_id: formData.get("user_id"),
            //     filename: file.name,
            // });
            // console.log("firstResponse", firstResponse);
            // setUploadProgress(10);
            // const progressInterval = startProgressTimer();
            //
            // const secondResponse = await axios.put(firstResponse.data.message.presigned_url, file, {
            //     headers: {
            //         'Content-Type': 'application/mp4'
            //     }
            // });
            //
            // if (secondResponse.status === 200) {
            //     console.log('PDF uploaded successfully AWS!', secondResponse);
            //     setUploadProgress(24);
            // } else {
            //     console.error('Failed to upload PDF AWS:', secondResponse.statusText);
            // }
            // formData.append("file_id", firstResponse.data.message.file_id)
            // clearInterval(progressInterval);
            // const response = await axios.post(serverIPs.SERVER_IP + '/videos/video', formData, {
            //     onUploadProgress: (progressEvent) => {
            //         console.log("Progress Event", progressEvent);
            //         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            //         setUploadProgress(percentCompleted);
            //     }
            // });
            // console.log('Uploaded BWC VIDEO Response:', response);
            // 1️⃣  INITIATE
            const { file_id, presigned_urls } = await initiateMultipartUpload(
                serverIPs.SERVER_IP,
                localStorage.getItem("userID"),
                file.name,
                file.size
            );
                setUploadProgress(2);

            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
            const etagValues = await uploadMultipartParts(
                file,
                presigned_urls,
                (percent) => setUploadProgress(percent)
            );

            // 3️⃣  COMPLETE
            await completeMultipartUpload(
                serverIPs.SERVER_IP,
                localStorage.getItem("userID"),
                file_id,
                etagValues
            );
            setUploadProgress(100);

            // 4️⃣  Tell your backend to begin processing
            const formData = new FormData();
            formData.append("data_type", "file");
            formData.append("user_id", localStorage.getItem("userID"));
            formData.append("file_id", file_id);

            if (file.type === "audio/mpeg") {
                formData.append("file_type", "mp3");
            }

            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);

            const response = await axios.post(
                `${serverIPs.SERVER_IP}/videos/video`,
                formData,
                {
                    onUploadProgress: ev => {
                        const pct = Math.round((ev.loaded * 100) / ev.total);
                        setUploadProgress(pct);
                    }
                }
            );

            console.log('Uploaded BWC VIDEO Response FINAL:', response);

            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);

            if (response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                console.log("pricing_modal_shown")
                dispatch(setIsPricingModalOpen(true));
                localStorage.setItem("isUploadExceeded", "true");
                toast({
                    title: t("(Free Plan) Video Upload Limit Exceeded!"),
                    status: "info",
                    duration: 9000,
                    isClosable: true,
                    position: "top",
                });
            }

            if (response.data.status === 400 && response.data.message.message === "video transcription started") {
                dispatch(addVideo({
                    id: response.data.message.file_id,
                    name: file.name,
                    url: response.data.message.video_presigned_url,
                    thumbnail_url: "",
                    isLongLoading: true,
                    highlights: [],
                    messages: [],
                    messagesGeneration: [],
                }));
                const progressResult = await videoProgress(response.data.message.polling_progress_key);

                // If video transcription failed (response '400'), redirect to Gemini route
                if (progressResult === "400") {
                    console.log("Video transcription failed, redirecting to Gemini route");
                    toast({
                        title: "Redirecting...please wait",
                        status: "info",
                        duration: 5000,
                        isClosable: true,
                    });
                    navigate(`/video2/${response.data.message.file_id}`);
                    return; // Exit early to prevent normal video processing
                }
            }

            console.log("ADD VIDEO", response.data.message.video_presigned_url);
            dispatch(setOneVideo({
                id: response.data.message.file_id,
                name: file.name,
                url: response.data.message.video_presigned_url,
                thumbnail_url: "",
                isLongLoading: false,
                highlights: [],
                messages: [],
                messagesGeneration: [],
            }));
            toast({
                title: t("Video uploaded."),
                status: "success",
                duration: 9000,
                isClosable: true,
            });
            navigate("/?tab=videos");
        } catch (error) {
            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);
            toast({
                title: t('Oops, this video failed.'),
                description: t('Please try again or upload a different video.'),
                status: "error",
                duration: 9000,
                isClosable: true,
            })
            console.error('Error uploading the video:', error);
        }
    };

    const startPDFConversion = async (scanFileID, formData2, fileIndex = null) => {
        try {
            const convertToPDFResponse = await axios.post(serverIPs.SERVER_IP + '/convert/convert_to_pdf', formData2);
            console.log("response from /convert/convert_to_pdf", convertToPDFResponse)

            if (convertToPDFResponse.data.status === 200) {
                const convertToPDFResponse_file_id = convertToPDFResponse.data.message.file_id;
                const convertToPDFResponse_filename = convertToPDFResponse.data.message.filename;
                const convertToPDFResponse_progress_key = convertToPDFResponse.data.message.progress_key;

                const start = new Date().getTime() / 1000;

                // start polling another endpoint to check if the document is ready
                const interval = setInterval(async () => {
                    console.log("Pollkey", convertToPDFResponse_progress_key);
                    const res = await axios.post(serverIPs.SERVER_IP + '/general_progress', {
                        key: convertToPDFResponse_progress_key,
                    });
                    console.log("response from SERVER_IP_MULTIDOC /general_progress", res)

                    let file;
                    if (res.data.status === 200 && res.data.message.includes("replicate")) {
                        const pdfUrl = res.data.message;               // e.g. https://replicate.delivery/…/output.pdf
                        const {data: blob} = await axios.get(pdfUrl, {responseType: 'blob'});
                        file = new File([blob], `${convertToPDFResponse_filename}.pdf`, {type: 'application/pdf'});
                        clearInterval(interval);
                        // setIntervals(prevIntervals => {
                        //     const newIntervals = { ...prevIntervals };
                        //     delete newIntervals[scanFileID];
                        //     return newIntervals;
                        // });
                        // download the url in res.data.message, which is a PDF file, and then upload it through the /convert/upload_file route

                        const formData = new FormData();
                        formData.append('file', file, file.name);        // 3rd arg guarantees the filename
                        formData.append('user_id', localStorage.getItem('userID'));
                        formData.append('file_name', file.name);         // keeps backend happy
                        console.log("FORM DATA BELOW: ")
                        console.log(formData.get('file'));
                        console.log(formData.get('user_id'));
                        console.log(formData.get('file_name'));

                        // 1️⃣  INITIATE
                        let response;
                        const initiateResponse = await initiateMultipartUploadPDF(
                            serverIPs.SERVER_IP,
                            localStorage.getItem("userID"),
                            file.name,
                            file.size
                        );
                        if (initiateResponse === "File size is under 10MB") {
                            const formData = new FormData();
                            formData.append('file', file);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', file.name);
                            response = await axios.post(serverIPs.SERVER_IP + '/pdf', formData, {
                                onUploadProgress: (progressEvent) => {
                                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    setUploadProgress(percentCompleted);
                                }
                            });
                        } else {
                            const file_id = initiateResponse.file_id;
                            const presigned_urls = initiateResponse.presigned_urls;
                            setUploadProgress(2);

                            // Store the starting progress for mapping
                            const startingProgress = 2;
                            const progressRange = 15; // Always use 15% range

                            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
                            const etagValues = await uploadMultipartPartsPDF(
                                file,
                                presigned_urls,
                                (percent) => {
                                    // Map 0-100% from uploadMultipartPartsPDF to startingProgress to startingProgress+15%
                                    const mappedProgress = startingProgress + (percent / 100) * progressRange;
                                    setUploadProgress(Math.round(mappedProgress));
                                }
                            );

                            // 3️⃣  COMPLETE
                            await completeMultipartUploadPDF(
                                serverIPs.SERVER_IP,
                                localStorage.getItem("userID"),
                                file_id,
                                etagValues
                            );
                            setUploadProgress(100);

                            // 4️⃣  Tell your backend to begin processing
                            const formData = new FormData();
                            formData.append('file_id', file_id);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', file.name);

                            // console.log("Got HERE WDSFSDFDSFDSFSDF")
                            // console.log("FORM DATA BELOW Check this: ")
                            console.log(formData.get('file_id'));
                            console.log(formData.get('user_id'));
                            console.log(formData.get('file_name'));
                            response = await axios.post(
                                `${serverIPs.SERVER_IP}/pdf`,
                                formData,
                                {
                                    onUploadProgress: ev => {
                                        const pct = Math.round((ev.loaded * 100) / ev.total);
                                        setUploadProgress(pct);
                                    }
                                }
                            );
                        }
                        console.log('Uploaded PDF Document Response File Types:', response);
                        if (response.data.status === 207) {
                            dispatch(setScanType("normal"));
                            dispatch(setScanFileID(response.data.message.file_id));
                            dispatch(setScanEstimatedSeconds(response.data.message.time_estimate_seconds));
                            dispatch(setIsUploadLoading(false));
                            setUploadProgress(0);
                            onOpenScanModal1();
                            dispatch(setScanError(false));
                            dispatch(addDocument({
                                id: response.data.message.file_id,
                                name: response.data.message.filename,
                                url: response.data.message.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            return;
                        }

                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        if (response.data.status === 400) {
                            toast({
                                title: t("File is too large."),
                                description: t("We support up to 512 MB or 147,000 words"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        } else if (response.data.status === 401) {
                            toast({
                                title: t("Oops, this file failed."),
                                description: t("Please try again or upload a different file."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            // failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"),
                            //     document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                            console.log("pricing_modal_shown")
                            dispatch(setIsPricingModalOpen(true));
                            localStorage.setItem("isUploadExceeded", "true");
                            toast({
                                title: t("(Free Plan) File Upload Limit Exceeded!"),
                                status: "info",
                                duration: 9000,
                                isClosable: true,
                                position: "top",
                            });
                        }
                        else if (response.data.status === 402 && response.data.message === "PDF is corrupted, try uploading a different PDF") {
                            toast({
                                title: t("Oops, this file has corrupted bytes or is malformed"),
                                description: t("Please try again."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            // failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 403) {
                            toast({
                                title: t("Free Plan supports <= 20 pages for scanned file"),
                                description: t("Visit honeybear.ai/pricing to view Pro Plan pricing"),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 404) {
                            toast({
                                title: t("Scanned file Too Large"),
                                description: t("Pro Plan supports up to 500 pages for scanned files"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else {
                            dispatch(addDocument({
                                id: response.data.file_id,
                                name: response.data.filename,
                                url: response.data.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            toast({
                                title: t("File uploaded!"),
                                status: "success",
                                duration: 9000,
                                isClosable: true,
                            });
                        }
                    }
                    else {
                        // NEED TO EDIT INSIDE THIS ELSE STATEMENT FOR SHOWING BETTER PROGRESS UPDATES TO USER AND BETTER TIMING ESTIMATE INSTEAD OF JUST GUESSING - done
                        console.log("still processing")
                        const theSize = currentFileThatIsUploading ? currentFileThatIsUploading.size : 4 * 1024 * 1024;

                        const estimatedTimeConversion = Math.ceil(theSize / (1024 * 1024)) * 10; // 10 seconds per MB
                        let increment = 5;
                        if (estimatedTimeConversion) {
                            increment = 5 / (estimatedTimeConversion / 100);
                            // round to the nearest integer
                            increment = Math.round(increment);
                        }
                        // call setUploadProgress to set the progress equal to it plus the increment, but not over 91%
                        setUploadProgress(prev => Math.min(prev + increment, 91));

                    }
                }, 5000)
                // setInterval(interval)
            }
        } catch (error) {
            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);
            toast({
                title: t("Oops, this file failed."),
                description: t("Please try again or upload a different file."),
                status: "error",
                duration: 9000,
                isClosable: true,
            })
            // failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
            console.error('Error uploading the file:', error);
        }
    };

    const [currentFileThatIsUploading, setCurrentFileThatIsUploading] = useState(null);

    // Define the upload function based on the user authentication state
    const handleFileUpload = async (event, isAudiobook) => {
        console.log("USERID BELOW: ")
        //console.log(localStorage.getItem("userID"));

        const document = event.target.files[0];
        setCurrentFileThatIsUploading(document);
        if (localStorage.getItem("userID") !== null) {
            if (document) {
                if (document.type === 'application/pdf') {
                    dispatch(setIsUploadLoading(true));
                    // const formData = new FormData();
                    // formData.append('file', document);
                    // formData.append('user_id', localStorage.getItem("userID"));
                    // formData.append('file_name', document.name);

                    try {
                        const start = new Date().getTime() / 1000;
                        // 1️⃣  INITIATE
                        let response;
                        const initiateResponse = await initiateMultipartUploadPDF(
                            serverIPs.SERVER_IP,
                            localStorage.getItem("userID"),
                            document.name,
                            document.size
                        );
                        if (initiateResponse === "File size is under 10MB") {
                            const formData = new FormData();
                            formData.append('file', document);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', document.name);
                            response = await axios.post(serverIPs.SERVER_IP + '/pdf', formData, {
                                onUploadProgress: (progressEvent) => {
                                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    setUploadProgress(percentCompleted);
                                }
                            });
                        } else {
                            const file_id = initiateResponse.file_id;
                            const presigned_urls = initiateResponse.presigned_urls;
                            setUploadProgress(2);

                            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
                            const etagValues = await uploadMultipartPartsPDF(
                                document,
                                presigned_urls,
                                (percent) => setUploadProgress(percent)
                            );

                            // 3️⃣  COMPLETE
                            await completeMultipartUploadPDF(
                                serverIPs.SERVER_IP,
                                localStorage.getItem("userID"),
                                file_id,
                                etagValues
                            );
                            setUploadProgress(100);

                            // 4️⃣  Tell your backend to begin processing
                            const formData = new FormData();
                            formData.append('file_id', file_id);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', document.name);

                            response = await axios.post(
                                `${serverIPs.SERVER_IP}/pdf`,
                                formData,
                                {
                                    onUploadProgress: ev => {
                                        const pct = Math.round((ev.loaded * 100) / ev.total);
                                        setUploadProgress(pct);
                                    }
                                }
                            );
                            // setUploadProgress(0);
                            // dispatch(setIsUploadLoading(false));
                        }
                        console.log('Uploaded PDF Document Response:', response);
                        const end = new Date().getTime() / 1000;
                        const duration = end - start;
                        console.log("DURATION OF NORMAL UPLOAD JUSTIFY", duration)
                        // export const createAudiobook = async (file_id, user_id, serverIP, toast) => {
                        if (isAudiobook && response.data.status !== 207) {
                            // kicks off an async job.
                            console.log("create_audiobook_clicked");
                            createAudiobook(response.data.file_id, localStorage.getItem("userID"), serverIPs.SERVER_IP, toast).then(r => {
                                // at this point the new upload is on the grid view. Either call /start_session right automatically or wait for
                                // the user to click on the grid item
                                console.log("createAudiobook response", r);
                                // dispatch(setOutlineInAudiobook({documentID: response.data.file_id, outline: r.outline}));
                                // [{
                                //     start_page: 0,
                                //     end_page: 0,
                                //     title: "Chapter 1",
                                // }, {
                                //     start_page: 0,
                                //     end_page: 0,
                                //     title: "Chapter 2",
                                // }]

                            });
                        }


                        if (response.data.status === 207) {
                            if (isAudiobook) {
                                dispatch(setScanType("audiobook"));
                            } else {
                                dispatch(setScanType("normal"));
                            }
                            dispatch(setScanFileID(response.data.message.file_id));
                            dispatch(setScanEstimatedSeconds(response.data.message.time_estimate_seconds));
                            dispatch(setIsUploadLoading(false));
                            setUploadProgress(0);
                            onOpenScanModal1();
                            dispatch(setScanError(false));
                            if (isAudiobook) {
                                dispatch(addAudiobook({
                                    id: response.data.message.file_id,
                                    name: response.data.message.filename,
                                    url: response.data.message.url,
                                    highlights: [],
                                    messages: [],
                                    outline: [],
                                    pageAudioURLs: [],
                                }));
                            } else {
                                dispatch(addDocument({
                                    id: response.data.message.file_id,
                                    name: response.data.message.filename,
                                    url: response.data.message.url,
                                    highlights: [],
                                    messages: [],
                                    messagesGeneration: [],
                                }));
                            }
                            return;
                        }



                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        if (response.data.status === 400) {
                            toast({
                                title: t("PDF is too large."),
                                description: t("We support up to 512 MB or 147,000 words"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        } else if (response.data.status === 401) {
                            failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"),
                                document, serverIPs.SERVER_IP)
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                            console.log("pricing_modal_shown")
                            dispatch(setIsPricingModalOpen(true));
                            localStorage.setItem("isUploadExceeded", "true");
                            toast({
                                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                status: "info",
                                duration: 9000,
                                isClosable: true,
                                position: "top",
                            });
                        }
                        else if (response.data.status === 402 && response.data.message === "PDF is corrupted, try uploading a different PDF") {
                            toast({
                                title: t("Oops, this PDF has corrupted bytes or is malformed"),
                                description: t("Please try again. (Or try converting it to DOCX and back to PDF and upload that new PDF)"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 403) {
                            toast({
                                title: t("Free Plan supports <= 20 pages for scanned PDFs"),
                                description: t("Visit justifyai.app/pricing to view Pro Plan pricing"),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 404) {
                            toast({
                                title: t("Scanned PDF Too Large"),
                                description: t("Pro Plan supports up to 500 pages for scanned PDFs"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else {
                            if (isAudiobook) {
                                console.log("add audiobook here");
                                dispatch(addAudiobook({
                                    id: response.data.file_id,
                                    name: response.data.filename,
                                    url: response.data.url,
                                    highlights: [],
                                    messages: [],
                                    outline: [],
                                    pageAudioURLs: [],
                                }));
                                toast({
                                    title: t("Uploaded."),
                                    status: "success",
                                    duration: 9000,
                                    isClosable: true,
                                });
                            } else {
                                dispatch(addDocument({
                                    id: response.data.file_id,
                                    name: response.data.filename,
                                    url: response.data.url,
                                    highlights: [],
                                    messages: [],
                                    messagesGeneration: [],
                                }));
                                toast({
                                    title: t("Document uploaded."),
                                    status: "success",
                                    duration: 9000,
                                    isClosable: true,
                                });
                            }
                        }
                    } catch (error) {
                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        toast({
                            title: t("Oops, this PDF failed."),
                            description: t("Please try again or upload a different PDF."),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        console.error('Error uploading the document:', error);
                    }
                } else {
                    // WORKING HERE IN THIS ELSE STATEMENT TO SUPPORT ALL FILE TYPES
                    dispatch(setIsUploadLoading(true));
                    setUploadProgress(2);

                    const formData = new FormData();
                    const formUserID = localStorage.getItem("userID");
                    const formFile = document;
                    formData.append('file', formFile);
                    formData.append('user_id', formUserID);

                    try {
                        // if the file size is greater than 15 MB
                        if (formFile.size > 15 * 1024 * 1024) {
                            // 1️⃣  INITIATE
                            let fileExtension = getFileExtension(formFile);
                            console.log("fileExtension", fileExtension)

                            // remove the . from the beginning of the file extension
                            fileExtension = fileExtension.startsWith('.') ? fileExtension.slice(1) : fileExtension;

                            const initiateResponse = await initiateMultipartUploadConversion(
                                serverIPs.SERVER_IP,
                                formUserID,
                                formFile.name,
                                formFile.size,
                                fileExtension
                            );
                            const file_id = initiateResponse.file_id;
                            const presigned_urls = initiateResponse.presigned_urls;
                            setUploadProgress(5);

                            // Store the starting progress for mapping
                            const startingProgress = 5;
                            const progressRange = 15; // Always use 15% range

                            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
                            const etagValues = await uploadMultipartPartsConversion(
                                formFile,
                                presigned_urls,
                                (percent) => {
                                    // Map 0-100% from uploadMultipartPartsConversion to startingProgress to startingProgress+15%
                                    const mappedProgress = startingProgress + (percent / 100) * progressRange;
                                    setUploadProgress(Math.round(mappedProgress));
                                }
                            );

                            // 3️⃣  COMPLETE
                            const lastResponse = await completeMultipartUploadConversion(
                                serverIPs.SERVER_IP,
                                formUserID,
                                file_id,
                                etagValues
                            );
                            setUploadProgress(10);

                            const formData23 = new FormData();
                            formData23.append('user_id', lastResponse.data.message.user_id);
                            formData23.append('file_id', lastResponse.data.message.file_id);
                            formData23.append('filename_secure', lastResponse.data.message.filename);
                            formData23.append('file_extension', fileExtension);
                            formData23.append('socketio_stream_room', 'user_' + formUserID);

                            startPDFConversion(lastResponse.data.message.file_id, formData23, index); // start here down
                        }

                        // everything in the else statement below was the original code before June 28
                        else {
                            console.log("/convert/upload_file FORM DATA BELOW: ")
                            console.log(formData.forEach((value, key) => console.log(key + ' ' + value)));

                            setUploadProgress(5)
                            const singleUploadFileResponse = await axios.post(serverIPs.SERVER_IP + '/convert/upload_file', formData);
                            console.log("singleUploadFileResponse", singleUploadFileResponse);
                            setUploadProgress(10)

                            if (singleUploadFileResponse.data.status === 200) {
                                const singleUploadFileResponse_message = singleUploadFileResponse.data.message.message;
                                const singleUploadFileResponse_file_id = singleUploadFileResponse.data.message.file_id;
                                const singleUploadFileResponse_user_id = singleUploadFileResponse.data.message.user_id;
                                const singleUploadFileResponse_filename_secure = singleUploadFileResponse.data.message.filename_secure;
                                const singleUploadFileResponse_file_extension = singleUploadFileResponse.data.message.file_extension;

                                const formData2 = new FormData();
                                formData2.append('user_id', singleUploadFileResponse_user_id);
                                formData2.append('file_id', singleUploadFileResponse_file_id);
                                formData2.append('filename_secure', singleUploadFileResponse_filename_secure);
                                formData2.append('file_extension', singleUploadFileResponse_file_extension);
                                formData2.append('socketio_stream_room', 'user_' + localStorage.getItem('userID'));

                                startPDFConversion(singleUploadFileResponse_file_id, formData2, index);
                            } else if (singleUploadFileResponse.data.status === 400 && singleUploadFileResponse.data.message.includes("is not supported")) {
                                dispatch(setIsUploadLoading(false));
                                setUploadProgress(0);
                                toast({
                                    title: t("This file type isn't supported"),
                                    description: "We support .pdf, .png, .jpg, " +
                                        ".docx, .pptx, .xlsx, .txt, .csv, .html, .epub, .key, .mp4, .mp3, .mov, .rtf, .pages, .numbers",
                                    status: "error",
                                    duration: 11000,
                                    isClosable: true,
                                })
                            }
                        }
                    } catch (error) {
                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        toast({
                            title: t("Oops, this file failed."),
                            description: t("Please try again or upload a different file."),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        // failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        console.error('Error uploading the file:', error);
                    }
                    // I'M HERE!!!!!!!!!!!!!!
                    // toast({
                    //     title: t("Single-Upload only supports PDFs"),
                    //     description: t("Click the 'Multi-Upload' tab at the top to upload other file types"),
                    //     status: "error",
                    //     duration: 20000,
                    //     isClosable: true,
                    // })
                }
            }
        } else {
            if (document) {
                if (getDocumentsInStorage().length === 1) {
                    toast({
                        title: t("You've reached your document limit in guest mode!"),
                        description: t("Please sign up to continue uploading documents."),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    onOpenSignUpScreen1()
                    return;
                }
                if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                    toast({
                        title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    dispatch(setIsPricingModalOpen(true));
                    return;
                }
                if (document.type === 'application/pdf') {
                    dispatch(setIsUploadLoading(true));
                    const formData = new FormData();
                    formData.append('file', document);
                    formData.append('user_id', "11111111-1111-1111-1111-111111111111");
                    formData.append('file_name', document.name);
                    try {
                        const response = await axios.post(serverIPs.SERVER_IP + '/pdf', formData, {
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(percentCompleted);
                            }
                        });



                        if (response.data.status === 207) {
                            dispatch(setScanType("normal"));
                            dispatch(setScanFileID(response.data.message.file_id));
                            dispatch(setScanEstimatedSeconds(response.data.message.time_estimate_seconds));
                            dispatch(setIsUploadLoading(false));
                            setUploadProgress(0);
                            onOpenScanModal1();
                            dispatch(setScanError(false));
                            dispatch(addDocument({
                                id: response.data.message.file_id,
                                name: response.data.message.filename,
                                url: response.data.message.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            return;
                        }



                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        if (response.data.status === 400) {
                            toast({
                                title: t("PDF is too large."),
                                description: t("We support up to 512 MB or 147,000 words"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 401) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 402) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        } else if (response.data.status === 403) {
                            toast({
                                title: t("Free Plan supports <= 20 pages for scanned PDFs"),
                                description: t("Visit justifyai.app/pricing to view Pro Plan pricing"),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 404) {
                            toast({
                                title: t("Scanned PDF Too Large"),
                                description: t("Pro Plan supports up to 500 pages for scanned PDFs"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else {
                            addDocumentInStorage({
                                id: response.data.file_id,
                                name: response.data.filename,
                                url: response.data.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            })
                            auth.setPlaygroundDocuments(getDocumentsInStorage());
                            dispatch(addDocument({
                                id: response.data.file_id,
                                name: response.data.filename,
                                url: response.data.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            toast({
                                title: t("Document uploaded."),
                                status: "success",
                                duration: 9000,
                                isClosable: true,
                            })
                        }

                    } catch (error) {
                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        toast({
                            title: t("Oops, this PDF failed."),
                            description: t("Please try again or upload a different PDF."),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        console.error('Error uploading the document:', error);
                    }
                } else {
                    toast({
                        title: t("Upload failed."),
                        description: t("When not signed in, we only support PDFs. Please sign up for an account!"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
            }
        }
    };

    const handleFileUploadImage = async (event) => {
        const files = Array.from(event.target.files);

        if (files.length === 0) return;

        setCurrentFileThatIsUploading(files[0]);
        setUploadProgress(6);

        // Initialize multidoc once for all images
        initializeMultidoc("Images Workspace", localStorage.getItem("userID"), serverIPs.SERVER_IP_MULTIDOC).then(async r => {
            if (r && r.status === 200) {
                console.log("initialize multidoc IMAGE JUSTIFY", r)
                dispatch(setIsUploadLoading(true));
                setUploadProgress(18);

                const formUserID = localStorage.getItem("userID");
                const totalFiles = files.length;
                let completedFiles = 0;
                const imageURLs = [];

                try {
                    // Function to upload a single image
                    const uploadSingleImage = async (file) => {
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('user_id', formUserID);

                        console.log("/convert/upload_file for:", file.name);

                        const singleUploadFileResponse = await axios.post(serverIPs.SERVER_IP + '/convert/upload_file', formData);
                        console.log("singleUploadFileResponse for", file.name, singleUploadFileResponse);

                        if (singleUploadFileResponse.data.status === 200) {
                            const singleUploadFileResponse_file_id = singleUploadFileResponse.data.message.file_id;
                            const singleUploadFileResponse_user_id = singleUploadFileResponse.data.message.user_id;

                            const addImageForNativeChatResponse = await axios.post(serverIPs.SERVER_IP + '/multidoc/add_file_for_native_chat', {
                                user_id: singleUploadFileResponse_user_id,
                                file_id: singleUploadFileResponse_file_id,
                                multidoc_id: r.id,
                            });
                            console.log("addImageForNativeChat RESPONSE for", file.name, addImageForNativeChatResponse);

                            if (addImageForNativeChatResponse.data.status === 200) {
                                // Update progress
                                completedFiles++;
                                const progressPercent = Math.floor((completedFiles / totalFiles) * 100);
                                setUploadProgress(progressPercent);

                                // Collect the image URL
                                const theImageURL = {
                                    url: addImageForNativeChatResponse.data.message.url.toString(),
                                    name: addImageForNativeChatResponse.data.message.file_name
                                };
                                return theImageURL;
                            }
                        }
                        throw new Error(`Failed to upload ${file.name}`);
                    };

                    // Upload all images in parallel
                    const uploadPromises = files.map(file => uploadSingleImage(file));
                    const results = await Promise.all(uploadPromises);

                    // Collect all successful URLs
                    imageURLs.push(...results.filter(result => result !== undefined));
                    createMultidocSessionNativeChat(r.id, formUserID, serverIPs.SERVER_IP_MULTIDOC).then(createResponse => {
                        console.log("createMultidocSessionNativeChat for images", createResponse);

                        const dataWithTimestamp = {
                            progressKey: createResponse.progressKey,
                            sessionToken: createResponse.multidocSessionToken,
                            timestamp: Date.now()
                        };

                        localStorage.setItem("createMultidocSessionNativeChat", JSON.stringify(dataWithTimestamp));
                    });

                    console.log("All images uploaded:", imageURLs);

                    // Dispatch once with all URLs
                    dispatch(setIsUploadLoading(false));
                    setUploadProgress(0);

                    dispatch(addDocumentGenerationNative({
                        id: r.id,
                        name: imageURLs.length > 1 ? `${imageURLs.length} Images` : imageURLs[0].name,
                        urls: imageURLs,
                        messages: [],
                        files: [],
                        lastOpenTime: Date.now()
                    }));
                    dispatch(addDocumentGeneration({
                        id: r.id,
                        name: imageURLs.length > 1 ? `${imageURLs.length} Images` : imageURLs[0].name,
                        urls: imageURLs,
                        messages: [],
                        files: [],
                        lastOpenTime: Date.now()
                    }));

                    toast({
                        title: t(imageURLs.length > 1 ? `${imageURLs.length} images uploaded.` : "Image uploaded."),
                        status: "success",
                        duration: 9000,
                        isClosable: true,
                    });

                } catch (error) {
                    dispatch(setIsUploadLoading(false));
                    setUploadProgress(0);
                    toast({
                        title: t("Oops, some images failed."),
                        description: t("Please try again or upload different images."),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                    console.error('Error uploading images:', error);
                }
            } else {
                console.error("Failed to initialize multidoc IMAGE JUSTIFY:", r);
            }
        });
    };

    const handleYoutubeLinkUpload = async (url) => {
        console.log("YOUTUBE URL", url);
        if (localStorage.getItem("userID") !== null) {
            if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                toast({
                    title: t("(Free Plan) Video Upload Limit Exceeded!"),
                    status: "info",
                    duration: 9000,
                    isClosable: true,
                    position: "top",
                });
                dispatch(setIsPricingModalOpen(true));
                return;
            }
            dispatch(setIsUploadLoading(true));
            const formData = new FormData();
            formData.append('yt_link', url);
            formData.append('data_type', "yt_link");
            formData.append('user_id', localStorage.getItem("userID"));

            // console.log("video input", {
            //     yt_link: url,
            //     data_type: "yt_link",
            //     user_id: localStorage.getItem("userID"),
            // })
            try {
                const response = await axios.post(serverIPs.SERVER_IP_VIDEO + '/videos/video', formData, {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    }
                });
                console.log('Uploaded Video Response new:', response);
                dispatch(setIsUploadLoading(false));
                setUploadProgress(0);
                if (response.data.status === 400 && (response.data.message === "Invalid YouTube link" || response.data.message === "Invalid video ID")) {
                    console.log("video_upload_error")
                    toast({
                        title: t("Invalid YouTube link"),
                        description: t("Please enter a valid YouTube link"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400 && response.data.message === "YouTube request failed") {
                    console.log("video_upload_error")
                    toast({
                        title: t("Upload Failed"),
                        description: t("Please try again or upload a different video"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400 && response.data.message === "Video unavailable") {
                    console.log("video_upload_error")
                    toast({
                        title: t("Video is unavailable"),
                        description: t("Please make sure it's not a private video"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400 && (response.data.message === "No transcript available"
                    || response.data.message === "No transcript found" || response.data.message === "Transcript is None for some reason")) {
                    console.log("video_upload_error")
                    toast({
                        title: t("Video doesn't have a transcript"),
                        description: t("Please try a different video"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400 && response.data.message.startsWith("Error getting transcript:")) {
                    console.log("video_upload_error")
                    toast({
                        title: t("Please try again!"),
                        description: t("If the issue persists, please try a different video as this video may not have a transcript"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400 && response.data.message.startsWith("Error: ")) {
                    console.log("video_upload_error")
                    toast({
                        title: t("Please try again!"),
                        description: t("If the issue persists, please try a different video"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400
                    && response.data.message === "Video transcript too big, try working with a smaller video") {
                    console.log("video_upload_error")
                    toast({
                        title: t("Video too large"),
                        description: t("Please try a shorter length video"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                    console.log("pricing_modal_shown")
                    dispatch(setIsPricingModalOpen(true));
                    localStorage.setItem("isUploadExceeded", "true");
                    toast({
                        title: t("(Free Plan) Upload Limit Exceeded!"),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                }
                else {
                    console.log("video_upload_success")
                    dispatch(addVideo({
                        id: response.data.file_id,
                        name: response.data.filename,
                        url: response.data.url,
                        thumbnail_url: response.data.thumbnail_presigned_url,
                        highlights: [],
                        messages: [],
                        messagesGeneration: [],
                    }));
                    toast({
                        title: t("Video uploaded."),
                        status: "success",
                        duration: 9000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                console.log("video_upload_error")
                dispatch(setIsUploadLoading(false));
                setUploadProgress(0);
                toast({
                    title: t("Oops, this Video Upload failed."),
                    description: t("Please try again or upload a different video."),
                    status: "error",
                    duration: 9000,
                    isClosable: true,
                })
                console.error('Error uploading the video:', error);
            }
        }
        // else {
        //         if (getDocumentsInStorage().length === 1) {
        //             toast({
        //                 title: t("You've reached your document limit in guest mode!"),
        //                 description: t("Please sign up to continue uploading documents."),
        //                 status: "info",
        //                 duration: 9000,
        //                 isClosable: true,
        //                 position: "top",
        //             });
        //             onOpenSignUpScreen1()
        //             return;
        //         }
        //         if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
        //             toast({
        //                 title: t("(Free Plan) PDF Upload Limit Exceeded!"),
        //                 status: "info",
        //                 duration: 9000,
        //                 isClosable: true,
        //                 position: "top",
        //             });
        //             dispatch(setIsPricingModalOpen(true));
        //             return;
        //         }
        //         dispatch(setIsUploadLoading(true));
        //         try {
        //             const response = await axios.post(SERVER_IP + '/videos/video', {
        //                 yt_link: url,
        //                 data_type: "yt_link",
        //                 user_id: "11111111-1111-1111-1111-111111111111",
        //             }, {
        //                 onUploadProgress: (progressEvent) => {
        //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //                     setUploadProgress(percentCompleted);
        //                 }
        //             });
        //             dispatch(setIsUploadLoading(false));
        //             setUploadProgress(0);
        //             if (response.data.status === 400) {
        //                 toast({
        //                     title: t("PDF is too large."),
        //                     description: t("We support up to 512 MB or 147,000 words"),
        //                     status: "error",
        //                     duration: 9000,
        //                     isClosable: true,
        //                 })
        //             }
        //             else {
        //                 addDocumentInStorage({
        //                     id: response.data.file_id,
        //                     name: response.data.filename,
        //                     url: response.data.url,
        //                     thumbnail: response.thumbnail_presigned_url,
        //                     highlights: [],
        //                     messages: [],
        //                     messagesGeneration: [],
        //                 })
        //                 auth.setPlaygroundDocuments(getDocumentsInStorage());
        //                 dispatch(addVideo({
        //                     id: response.data.file_id,
        //                     name: response.data.filename,
        //                     url: response.data.url,
        //                     thumbnail_url: response.thumbnail_presigned_url,
        //                     highlights: [],
        //                     messages: [],
        //                     messagesGeneration: [],
        //                 }));
        //                 toast({
        //                     title: t("Video uploaded."),
        //                     status: "success",
        //                     duration: 9000,
        //                     isClosable: true,
        //                 })
        //             }
        //
        //         } catch (error) {
        //             dispatch(setIsUploadLoading(false));
        //             setUploadProgress(0);
        //             toast({
        //                 title: t("Oops, this PDF failed."),
        //                 description: t("Please try again or upload a different PDF."),
        //                 status: "error",
        //                 duration: 9000,
        //                 isClosable: true,
        //             })
        //             console.error('Error uploading the document:', error);
        //         }
        // }
    }

    // Select the correct document list based on authentication
    const documents = useSelector(state => state.documents.savedDocuments);
    const videos = useSelector(state => state.documents.savedVideos);
    const generations = useSelector(state => state.documents.savedGenerations);
    const audiobooks = useSelector(state => state.documents.savedGenerationsNative);
    const anara = useSelector(state => state.documents.savedAnara);

    // CHANGE THIS FOR VIDEOS LATER
    useEffect(() => {
        const tempUserID = localStorage.getItem("userID");

        if (tempUserID !== null) {
            // Get the current search parameters
            // const currentSearchParams = new URLSearchParams(window.location.search);
            // const currentTab = currentSearchParams.get('tab');

            // // Decide navigation based on the user's entered path or default
            // if (currentTab === 'videos') {
            //     navigate('/?tab=videos'); // Stay on videos
            //     setTabIndex(2);
            // } else if (currentTab === 'multidoc') {
            //     navigate('/?tab=multidoc'); // Stay on multidocs
            //     setTabIndex(1);
            // } else if (currentTab === 'pdfs' || currentTab === null) {
            //     // Default to PDFs if no `tab` query or explicitly `tab=pdfs`
            //     navigate('/?tab=pdfs');
            //     setTabIndex(0);
            // }

            // Fetch documents and videos
            fetchDocuments(tempUserID, serverIPs.SERVER_IP).then(r => {
                dispatch(setDocuments(r.documents));
            });
            fetchVideos(tempUserID, serverIPs.SERVER_IP_VIDEO).then(r => {
                dispatch(setVideos(r.videos));
            });
            fetchMultidocs(tempUserID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                dispatch(setDocumentsGeneration(r.multidocs));
            });
            fetchMultidocsNative(tempUserID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                dispatch(setDocumentsGenerationNative(r.multidocs));
            });
            // fetchAudiobooks(tempUserID, serverIPs.SERVER_IP).then(r => {
            //     dispatch(setAudiobooks(r.audiobooks));
            // });
        }
    }, []);


    const placeholders = ["https://www.youtube.com/watch?v=aJwdWeiSc8c",
        "https://www.youtube.com/watch?v=nyOD7m4uOv8"];
    const [currentPlaceholder, setCurrentPlaceholder] = useState(placeholders[0]);
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true); // State to manage fade in and out
    const [urlInput, setUrlInput] = useState("");

    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         setFade(false); // Fade out the current placeholder
    //
    //         setTimeout(() => {
    //             // After fade out, change the placeholder and fade it in
    //             setIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    //             setCurrentPlaceholder(placeholders[index]);
    //             setFade(true);
    //         }, 750); // Half the interval time to allow for fade in and fade out
    //     }, 1500);
    //
    //     return () => clearInterval(intervalId);
    // }, [index]);

    const handleSubmit = () => {
        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload YouTube videos",
                description: "Then you can chat with them just like with normal PDFs!",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
        } else {
            setUrlInput("");
            handleYoutubeLinkUpload(urlInput).then(r => {
                setUrlInput("")
                navigate('/?tab=videos');
            });
        }
    };

    const [tabIndex, setTabIndex] = useState(0);
    const [workspaceLoading, setWorkspaceLoading] = useState(false);
    const areAllFilesEmpty = (...fileArrays) => {
        return fileArrays.every(fileArray => fileArray.length === 0) && !auth.isLoggedIn;
    };

    const isAnyFileNonEmpty = (...fileArrays) => {
        return fileArrays.some(fileArray => fileArray.length !== 0);
    };

    const renderTabContent = () => {
        if (tabIndex === 0) {
            return documents.length !== 0 ? (
                <DocumentGrid navigate={navigate} />
            ) : (
                <DocumentGridEmpty />
            );
        }

        if (tabIndex === 1) {
            return generations.length !== 0 ? (
                <DocumentGridGeneration navigate={navigate} />
            ) : (
                <DocumentGridGenerationEmpty />
            );
        }

        if (tabIndex === 2) {
            return videos.length !== 0 ? (
                <DocumentGridVideos navigate={navigate} />
            ) : (
                <DocumentGridVideosEmpty />
            );
        }

        if (tabIndex === 3) {
            return audiobooks.length !== 0 ? (
                <DocumentGridAudiobooks navigate={navigate} />
            ) : (
                <DocumentGridAudiobooksEmpty />
            );
        }

        if (tabIndex === 4) {
            return videos.length !== 0 ? (
                <DocumentGridMembers navigate={navigate} />
            ) : (
                <DocumentGridMembersEmpty />
            );
        }

        if (tabIndex === 5) {
            return videos.length !== 0 ? (
                <DocumentGridMembers navigate={navigate} />
            ) : (
                <DocumentGridMembersEmpty />
            );
        }
        
        return null; // Default case if tabIndex is not 0, 1, or 2
    };

    return (
        <div>
            <FullScreenTemplateHomePage navigateToTestimonials={navigateToTestimonials} navigateToFeatures={navigateToFeatures}>
                <VStack width={'100%'} height={'100%'} justifyContent={'center'} display={'flex'} spacing={'4rem'}
                        mt={areAllFilesEmpty(documents, videos, generations, audiobooks) ? '3.5rem' : '0rem'}>
                    {isAnyFileNonEmpty(documents, videos, generations, audiobooks) || auth.isLoggedIn ?
                        isUploadLoading ?
                            <Box width={'60%'} pt={'3.5rem'}>
                                <LoadingBar progress={uploadProgress} isMarginBottom={true}/>
                            </Box> :
                            <VStack width={"100%"} height={'21.75rem'} mb={'1rem'} spacing={6} py={'1.75rem'}
                                    bg={lightTheme.colors.lightGray}>
                                <VStack
                                    width={{
                                        base: '88%',
                                        sm: '70%',
                                        md: '60%',
                                        lg: '55%',
                                        xl: '50%',
                                    }}
                                    bg={'white'}
                                    height={'18rem'}
                                    borderRadius={'15px'}
                                    spacing={4}
                                    borderColor={'lightgray'}
                                    borderWidth={0.25}
                                    shadow={`1.5px 1.8px 0px lightgray`}
                                    position="relative"
                                >
                                    <Tabs
                                        variant="soft-rounded"
                                        colorScheme="orange"
                                        onChange={handleTabChange}
                                        index={tabIndex}
                                        width="100%"
                                        position="absolute"
                                        top="0rem"
                                        left="0rem"
                                        zIndex={1}
                                    >
                                        <TabList>
                                            <Tab borderTopLeftRadius={'15px'}
                                                 borderTopRightRadius={'0px'}
                                                 borderBottomRadius={'0px'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 sx={{
                                                     color: 'gray.600', // Default color
                                                     _selected: {
                                                         color: 'black', // Color when selected
                                                         bg: 'orange.100', // Background color when selected
                                                     },
                                                 }}
                                                 fontSize={!isMobile ? 15 : 13}>Single-Upload</Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                 // borderLeftWidth={'0.25px'}
                                                 // borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center">
                                                    Multi-Upload
                                                </Box>
                                            </Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                // borderLeftWidth={'0.25px'}
                                                // borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center">
                                                    Videos/Audio
                                                </Box>
                                            </Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                // borderLeftWidth={'0.25px'}
                                                // borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center">
                                                    Images
                                                </Box>
                                            </Tab>
                                        </TabList>

                                        <TabPanels px={2.5}>
                                            <TabPanel>
                                                {/* PDF Upload UI */}
                                                <MotionBox
                                                    {...getRootProps()}
                                                    border="2px"
                                                    borderColor="orange.400"
                                                    borderRadius="md"
                                                    borderStyle="dashed"
                                                    textAlign="center"
                                                    p="3"
                                                    mt={4}
                                                    pt={'1.05rem'}
                                                    cursor="pointer"
                                                    _hover={{ bg: 'gray.100' }}
                                                    animate={isDragActive ? { scale: 1.05 } : { scale: 1 }}
                                                    transition={{ duration: 0.2 }}
                                                    width="100%"
                                                    height="9rem"
                                                    onClick={() => {
                                                        if (getDocumentsInStorage().length === 1 && !auth.isLoggedIn) {
                                                            toast({
                                                                title: t("You've reached your document limit in guest mode!"),
                                                                description: t("Please sign up to continue uploading documents."),
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            onOpenSignUpScreen1();
                                                        }
                                                        else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                            toast({
                                                                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            dispatch(setIsPricingModalOpen(true));
                                                        }
                                                        else {
                                                            fileInput.current.click();
                                                        }
                                                    }}
                                                >
                                                    <input {...getInputProps()} ref={fileInput}/>
                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                        ⇧
                                                    </Box>
                                                    <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                        {t("Drag & Drop")}
                                                    </Text>
                                                    <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                </MotionBox>
                                                {auth.isLoggedIn ?
                                                    <Text
                                                        color="gray.500"
                                                        fontSize={13}
                                                        textAlign="center"
                                                        mt={6}
                                                        fontWeight="500"
                                                    >
                                                        PDF, DOCX, PPTX, XLSX, PNG, JPG, TXT, CSV, HTML & more
                                                    </Text> : null}
                                            </TabPanel>

                                            {/*Multi-PDF Upload UI*/}
                                            <TabPanel>
                                                <VStack>
                                                    {auth.isLoggedIn ?
                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                            Chat with multiple files at the same time
                                                        </Text> :
                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                            Please sign up to chat with multiple files at the same time
                                                        </Text>
                                                    }

                                                    <Button
                                                        borderRadius={12}
                                                        isLoading={workspaceLoading}
                                                        px={6}
                                                        py={6}
                                                        fontSize={18}
                                                        colorScheme={'orange'}
                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                        _hover={{
                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                        }}
                                                        onClick={() => {
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up to upload multiple files",
                                                                    description: "Then you can chat with all of them at the same time!",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                setWorkspaceLoading(true);
                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                    setWorkspaceLoading(false);
                                                                    navigate(`/multidoc/${r.id}`)
                                                                    window.location.reload();
                                                                    console.log("initialize multidoc here", r)
                                                                });
                                                            }

                                                        }}>
                                                        Create new Workspace
                                                    </Button>
                                                </VStack>
                                            </TabPanel>
                                            {/*Video/Audio Upload UI*/}
                                            <TabPanel>
                                                <MotionBox
                                                    {...getRootPropsVideo()}
                                                    border="3px"
                                                    borderColor={isDragActiveVideo ? "orange.500" : "orange.400"}
                                                    borderRadius="xl"
                                                    borderStyle="dashed"
                                                    textAlign="center"
                                                    p="6"
                                                    pt={2}
                                                    mt={4}
                                                    cursor="pointer"
                                                    bg={isDragActiveVideo ? 'orange.50' : 'white'}
                                                    _hover={{ bg: 'orange.50', borderColor: 'orange.500' }}
                                                    animate={isDragActiveVideo ? { scale: 1.02 } : { scale: 1 }}
                                                    transition={{ duration: 0.2 }}
                                                    width="100%"
                                                    minHeight="10rem"
                                                    display="flex"
                                                    flexDirection="column"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    gap="2"
                                                    onClick={() => {
                                                        if (!auth.isLoggedIn) {
                                                            toast({
                                                                title: "Please sign up to upload video/audio files",
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            onOpenSignUpScreen1();
                                                        }
                                                        else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                            toast({
                                                                title: t("(Free Plan) Video Upload Limit Exceeded!"),
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            dispatch(setIsPricingModalOpen(true));
                                                        }
                                                        else {
                                                            fileInputVideo.current.click();
                                                        }
                                                    }}
                                                >
                                                    <input {...getInputPropsVideo({ accept: 'video/*,audio/*' })} ref={fileInputVideo}/>
                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                        ⇧
                                                    </Box>
                                                    {/* Secondary Text */}
                                                    <Text color="gray.600" fontSize={!isMobile ? 16 : 15} fontWeight="medium" mt={-1}>
                                                        {t("Drag & drop or click to browse")}
                                                    </Text>

                                                    {/* Format Info */}
                                                    <Box
                                                        mt="2"
                                                        px="4"
                                                        py="1.5"
                                                        bg="orange.100"
                                                        borderRadius="full"
                                                        display="inline-flex"
                                                        alignItems="center"
                                                        gap="2"
                                                    >
                                                        <Text color="orange.700" fontSize={!isMobile ? 13 : 12} fontWeight="semibold">
                                                            supports any video/audio file
                                                        </Text>
                                                </Box>
                                                </MotionBox>
                                            </TabPanel>
                                            
                                            <TabPanel>
                                                <MotionBox
                                                    {...getRootPropsAudiobook()}
                                                    border="3px"
                                                    borderColor={isDragActiveAudiobook ? "orange.500" : "orange.400"}
                                                    borderRadius="xl"
                                                    borderStyle="dashed"
                                                    textAlign="center"
                                                    p="6"
                                                    pt={2}
                                                    mt={4}
                                                    cursor="pointer"
                                                    bg={isDragActiveAudiobook ? 'orange.50' : 'white'}
                                                    _hover={{ bg: 'orange.50', borderColor: 'orange.500' }}
                                                    animate={isDragActiveAudiobook ? { scale: 1.02 } : { scale: 1 }}
                                                    transition={{ duration: 0.2 }}
                                                    width="100%"
                                                    minHeight="10rem"
                                                    display="flex"
                                                    flexDirection="column"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    gap="2"
                                                    onClick={() => {
                                                        if (!auth.isLoggedIn) {
                                                            toast({
                                                                title: "Please sign up to upload images",
                                                                description: "analyze 1 or multiple images efficiently",
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            onOpenSignUpScreen1();
                                                        }
                                                        else {
                                                            fileInputAudiobook.current.click();
                                                        }
                                                    }}
                                                >
                                                    <input {...getInputPropsAudiobook({ accept: 'image/*', multiple: true })} ref={fileInputAudiobook}/>
                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                        ⇧
                                                    </Box>
                                                    {/* Secondary Text */}
                                                    <Text color="gray.600" fontSize={!isMobile ? 16 : 15} fontWeight="medium" mt={-1}>
                                                        {t("Drag & drop or click to browse")}
                                                    </Text>

                                                    {/* Format Info */}
                                                    <Box
                                                        mt="2"
                                                        px="4"
                                                        py="1.5"
                                                        bg="orange.100"
                                                        borderRadius="full"
                                                        display="inline-flex"
                                                        alignItems="center"
                                                        gap="2"
                                                    >
                                                        <Text color="orange.700" fontSize={!isMobile ? 13 : 12} fontWeight="semibold">
                                                            Supported: PNG, JPEG, JPG
                                                        </Text>
                                                    </Box>
                                                </MotionBox>
                                            </TabPanel>
                                        </TabPanels>
                                    </Tabs>
                                </VStack>
                            </VStack>
                        : null}
                    {
                        areAllFilesEmpty(documents, videos, generations, audiobooks) ? (
                            <Container maxW={'100%'} mt={'-8.1rem'} bg={'white'} align={'center'}>
                                <Stack
                                    textAlign={'center'}
                                    align={'center'}
                                    spacing={{ base: 8, md: 10 }}
                                    maxW={'7xl'}
                                    py={{ base: 20, md: 28 }}>
                                    {Object.keys(influencerMap).includes(localStorage.getItem('referralCodeInfluencer')) ?
                                        <Text className="caveat-influencer" mb={-4}>{influencerMap[localStorage.getItem('referralCodeInfluencer')]}</Text>
                                        :
                                        null}
                                    <VStack spacing={6}>
                                        <Heading
                                            fontSize={{ base: '5xl', md: '6xl', lg: '7xl' }}
                                            fontWeight="700"
                                            color="#1e293b"
                                            mt={!isMobile ? 0 : -1}
                                            lineHeight="1.05"
                                            letterSpacing="-0.025em"
                                        >
                                            Supercharge Your Work
                                            <br />
                                            AI for Private Investigators
                                        </Heading>

                                        <Text
                                            fontSize={{ base: 'lg', md: '2xl' }}
                                            color="#64748b"
                                            maxW="4xl"
                                            lineHeight="1.6"
                                            px={4}
                                            mt={4}
                                        >
                                            <Text as="span" fontWeight="bold">5x</Text>&nbsp;your work with our custom AI designed for private investigators.
                                            Extract key info from dense reports or video footage.
                                            Transcribe video/audio files or interviews. Always get quality responses with zero hallucinations.
                                        </Text>
                                    </VStack>
                                    <Stack spacing={6} direction={'row'}>
                                        <Button
                                            borderRadius={16}
                                            px={isMobile ? 6 : 7}
                                            py={isMobile ? 6 : 7}
                                            fontSize={isMobile ? 18 : 22}
                                            colorScheme={'black'}
                                            bgGradient="linear(to-r, gray.800, gray.900)"
                                            _hover={{
                                                bgGradient: "linear(to-r, gray.800, black)", // Adjusts the gradient on hover
                                                boxShadow: 'lg' // Adds a slight shadow on hover
                                            }}
                                            onClick={() => {
                                                if (auth.isLoggedIn) {
                                                    fileInput.current.click();
                                                } else {
                                                    onOpenSignUpScreen1();
                                                }
                                            }}>
                                            {auth.isLoggedIn ? t('Upload') : t('Get started')}
                                        </Button>
                                        {/*<Button rounded={'full'} px={6} onClick={() => {*/}
                                        {/*    navigateToFeatures();*/}
                                        {/*}}>*/}
                                        {/*    {t("Learn more")}*/}
                                        {/*</Button>*/}
                                    </Stack>
                                    <Flex w={'100%'} justifyContent={"center"} display={"flex"} flexDirection={'column'}
                                          alignItems={'center'}>
                                        {isUploadLoading ?
                                            <LoadingBar progress={uploadProgress} isMarginBottom={true}/> :
                                            
                                            <VStack width={"100%"} height={'21.75rem'} mb={'1rem'} spacing={6} py={'1.75rem'} pt={'1rem'}
                                                    bg={'white'}>
                                                <VStack
                                                    width={{
                                                        base: '88%',
                                                        sm: '70%',
                                                        md: '60%',
                                                        lg: '57%',
                                                        xl: '55%',
                                                    }}
                                                    bg={'white'}
                                                    height={'18rem'}
                                                    borderRadius={'15px'}
                                                    spacing={4}
                                                    borderColor={'lightgray'}
                                                    borderWidth={0.25}
                                                    shadow={`1.5px 1.8px 0px lightgray`}
                                                    position="relative"
                                                >
                                                    <Tabs
                                                        variant="soft-rounded"
                                                        colorScheme="orange"
                                                        onChange={handleTabChange}
                                                        index={tabIndex}
                                                        width="100%"
                                                        position="absolute"
                                                        top="0rem"
                                                        left="0rem"
                                                        zIndex={1}
                                                    >
                                                        <TabList>
                                                            <Tab borderTopLeftRadius={'15px'}
                                                                 borderTopRightRadius={'0px'}
                                                                 borderBottomRadius={'0px'}
                                                                 borderBottomWidth={'0.25px'}
                                                                 borderBottomColor={'orange.100'}
                                                                 sx={{
                                                                     color: 'gray.600', // Default color
                                                                     _selected: {
                                                                         color: 'black', // Color when selected
                                                                         bg: 'orange.100', // Background color when selected
                                                                     },
                                                                 }}
                                                                 fontSize={!isMobile ? 15 : 13}>Single-Upload</Tab>
                                                            <Tab borderRadius={'0px'} sx={{
                                                                color: 'gray.600', // Default color
                                                                _selected: {
                                                                    color: 'black', // Color when selected
                                                                    bg: 'orange.100', // Background color when selected
                                                                },
                                                            }} borderRightWidth={'0.25px'}
                                                                 borderRightColor={'orange.100'}
                                                                // borderLeftWidth={'0.25px'}
                                                                // borderLeftColor={'orange.100'}
                                                                 borderBottomWidth={'0.25px'}
                                                                 borderBottomColor={'orange.100'}
                                                                 fontSize={!isMobile ? 15 : 13}>
                                                                <Box display="flex" alignItems="center">
                                                                    Multi-Upload
                                                                </Box>
                                                            </Tab>
                                                            <Tab borderRadius={'0px'} sx={{
                                                                color: 'gray.600', // Default color
                                                                _selected: {
                                                                    color: 'black', // Color when selected
                                                                    bg: 'orange.100', // Background color when selected
                                                                },
                                                            }} borderRightWidth={'0.25px'}
                                                                 borderRightColor={'orange.100'}
                                                                // borderLeftWidth={'0.25px'}
                                                                // borderLeftColor={'orange.100'}
                                                                 borderBottomWidth={'0.25px'}
                                                                 borderBottomColor={'orange.100'}
                                                                 fontSize={!isMobile ? 15 : 13}>
                                                                <Box display="flex" alignItems="center">
                                                                    Videos/Audio
                                                                </Box>
                                                            </Tab>
                                                            <Tab borderRadius={'0px'} sx={{
                                                                color: 'gray.600', // Default color
                                                                _selected: {
                                                                    color: 'black', // Color when selected
                                                                    bg: 'orange.100', // Background color when selected
                                                                },
                                                            }} borderRightWidth={'0.25px'}
                                                                 borderRightColor={'orange.100'}
                                                                // borderLeftWidth={'0.25px'}
                                                                // borderLeftColor={'orange.100'}
                                                                 borderBottomWidth={'0.25px'}
                                                                 borderBottomColor={'orange.100'}
                                                                 fontSize={!isMobile ? 15 : 13}>
                                                                <Box display="flex" alignItems="center">
                                                                    Images
                                                                </Box>
                                                            </Tab>
                                                        </TabList>

                                                        <TabPanels px={2.5}>
                                                            <TabPanel>
                                                                {/* PDF Upload UI */}
                                                                <MotionBox
                                                                    {...getRootProps()}
                                                                    border="2px"
                                                                    borderColor="orange.400"
                                                                    borderRadius="md"
                                                                    borderStyle="dashed"
                                                                    textAlign="center"
                                                                    p="3"
                                                                    mt={4}
                                                                    pt={'1.05rem'}
                                                                    cursor="pointer"
                                                                    _hover={{ bg: 'gray.100' }}
                                                                    animate={isDragActive ? { scale: 1.05 } : { scale: 1 }}
                                                                    transition={{ duration: 0.2 }}
                                                                    width="100%"
                                                                    height="9.2rem"
                                                                    onClick={() => {
                                                                        if (getDocumentsInStorage().length === 1 && !auth.isLoggedIn) {
                                                                            toast({
                                                                                title: t("You've reached your document limit in guest mode!"),
                                                                                description: t("Please sign up to continue uploading documents."),
                                                                                status: "info",
                                                                                duration: 9000,
                                                                                isClosable: true,
                                                                                position: "top",
                                                                            });
                                                                            onOpenSignUpScreen1();
                                                                        }
                                                                        else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                                            toast({
                                                                                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                                                                status: "info",
                                                                                duration: 9000,
                                                                                isClosable: true,
                                                                                position: "top",
                                                                            });
                                                                            dispatch(setIsPricingModalOpen(true));
                                                                        }
                                                                        else {
                                                                            fileInput.current.click();
                                                                        }
                                                                    }}
                                                                >
                                                                    <input {...getInputProps()} ref={fileInput}/>
                                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                                        ⇧
                                                                    </Box>
                                                                    <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                                        {t("Drag & Drop")}
                                                                    </Text>
                                                                    <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                                </MotionBox>
                                                                {auth.isLoggedIn ?
                                                                    <Text
                                                                        color="gray.500"
                                                                        fontSize={13}
                                                                        textAlign="center"
                                                                        mt={6}
                                                                        fontWeight="500"
                                                                    >
                                                                        PDF, DOCX, PPTX, XLSX, PNG, JPG, TXT, CSV, HTML & more
                                                                    </Text> : null}
                                                            </TabPanel>

                                                            {/*Multi-PDF Upload UI*/}
                                                            <TabPanel>
                                                                <VStack>
                                                                    {auth.isLoggedIn ?
                                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                                            Chat with multiple files at the same time
                                                                        </Text> :
                                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                                            Please sign up to chat with multiple files at the same time
                                                                        </Text>
                                                                    }

                                                                    <Button
                                                                        borderRadius={12}
                                                                        isLoading={workspaceLoading}
                                                                        px={6}
                                                                        py={6}
                                                                        fontSize={18}
                                                                        colorScheme={'orange'}
                                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                                        _hover={{
                                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                                        }}
                                                                        onClick={() => {
                                                                            if (!auth.isLoggedIn) {
                                                                                toast({
                                                                                    title: "Please sign up to upload multiple files",
                                                                                    description: "Then you can chat with all of them at the same time!",
                                                                                    status: "info",
                                                                                    duration: 9000,
                                                                                    isClosable: true,
                                                                                    position: "top",
                                                                                });
                                                                                onOpenSignUpScreen1();
                                                                            } else {
                                                                                setWorkspaceLoading(true);
                                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                                    setWorkspaceLoading(false);
                                                                                    navigate(`/multidoc/${r.id}`)
                                                                                    window.location.reload();
                                                                                    console.log("initialize multidoc here", r)
                                                                                });
                                                                            }

                                                                        }}>
                                                                        Create new Workspace
                                                                    </Button>
                                                                </VStack>
                                                            </TabPanel>
                                                            {/*Video/Audio Upload UI*/}
                                                            <TabPanel>
                                                                <MotionBox
                                                                    {...getRootPropsVideo()}
                                                                    border="3px"
                                                                    borderColor={isDragActiveVideo ? "orange.500" : "orange.400"}
                                                                    borderRadius="xl"
                                                                    borderStyle="dashed"
                                                                    textAlign="center"
                                                                    p="6"
                                                                    pt={2}
                                                                    mt={4}
                                                                    cursor="pointer"
                                                                    bg={isDragActiveVideo ? 'orange.50' : 'white'}
                                                                    _hover={{ bg: 'orange.50', borderColor: 'orange.500' }}
                                                                    animate={isDragActiveVideo ? { scale: 1.02 } : { scale: 1 }}
                                                                    transition={{ duration: 0.2 }}
                                                                    width="100%"
                                                                    minHeight="10rem"
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    gap="2"
                                                                    onClick={() => {
                                                                        if (!auth.isLoggedIn) {
                                                                            toast({
                                                                                title: "Please sign up to upload video/audio files",
                                                                                status: "info",
                                                                                duration: 9000,
                                                                                isClosable: true,
                                                                                position: "top",
                                                                            });
                                                                            onOpenSignUpScreen1();
                                                                        }
                                                                        else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                                            toast({
                                                                                title: t("(Free Plan) Video Upload Limit Exceeded!"),
                                                                                status: "info",
                                                                                duration: 9000,
                                                                                isClosable: true,
                                                                                position: "top",
                                                                            });
                                                                            dispatch(setIsPricingModalOpen(true));
                                                                        }
                                                                        else {
                                                                            fileInputVideo.current.click();
                                                                        }
                                                                    }}
                                                                >
                                                                    <input {...getInputPropsVideo({ accept: 'video/*,audio/*' })} ref={fileInputVideo}/>
                                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                                        ⇧
                                                                    </Box>
                                                                    {/* Secondary Text */}
                                                                    <Text color="gray.600" fontSize={!isMobile ? 16 : 15} fontWeight="medium" mt={-1}>
                                                                        {t("Drag & drop or click to browse")}
                                                                    </Text>

                                                                    {/* Format Info */}
                                                                    <Box
                                                                        mt="2"
                                                                        px="4"
                                                                        py="1.5"
                                                                        bg="orange.100"
                                                                        borderRadius="full"
                                                                        display="inline-flex"
                                                                        alignItems="center"
                                                                        gap="2"
                                                                    >
                                                                        <Text color="orange.700" fontSize={!isMobile ? 13 : 12} fontWeight="semibold">
                                                                            supports any video/audio file
                                                                        </Text>
                                                                </Box>
                                                                </MotionBox>
                                                            </TabPanel>
                                                            <TabPanel>
                                                                <MotionBox
                                                                    {...getRootPropsAudiobook()}
                                                                    border="3px"
                                                                    borderColor={isDragActiveAudiobook ? "orange.500" : "orange.400"}
                                                                    borderRadius="xl"
                                                                    borderStyle="dashed"
                                                                    textAlign="center"
                                                                    p="6"
                                                                    pt={2}
                                                                    mt={4}
                                                                    cursor="pointer"
                                                                    bg={isDragActiveAudiobook ? 'orange.50' : 'white'}
                                                                    _hover={{ bg: 'orange.50', borderColor: 'orange.500' }}
                                                                    animate={isDragActiveAudiobook ? { scale: 1.02 } : { scale: 1 }}
                                                                    transition={{ duration: 0.2 }}
                                                                    width="100%"
                                                                    minHeight="10rem"
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    gap="2"
                                                                    onClick={() => {
                                                                        if (!auth.isLoggedIn) {
                                                                            toast({
                                                                                title: "Please sign up to upload images",
                                                                                description: "analyze 1 or multiple images efficiently",
                                                                                status: "info",
                                                                                duration: 9000,
                                                                                isClosable: true,
                                                                                position: "top",
                                                                            });
                                                                            onOpenSignUpScreen1();
                                                                        }
                                                                        else {
                                                                            fileInputAudiobook.current.click();
                                                                        }
                                                                    }}
                                                                >
                                                                    <input {...getInputPropsAudiobook({ accept: 'image/*', multiple: true })} ref={fileInputAudiobook}/>
                                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                                        ⇧
                                                                    </Box>
                                                                    {/* Secondary Text */}
                                                                    <Text color="gray.600" fontSize={!isMobile ? 16 : 15} fontWeight="medium" mt={-1}>
                                                                        {t("Drag & drop or click to browse")}
                                                                    </Text>

                                                                    {/* Format Info */}
                                                                    <Box
                                                                        mt="2"
                                                                        px="4"
                                                                        py="1.5"
                                                                        bg="orange.100"
                                                                        borderRadius="full"
                                                                        display="inline-flex"
                                                                        alignItems="center"
                                                                        gap="2"
                                                                    >
                                                                        <Text color="orange.700" fontSize={!isMobile ? 13 : 12} fontWeight="semibold">
                                                                            Supported: PNG, JPEG, JPG
                                                                        </Text>
                                                                    </Box>
                                                                </MotionBox>
                                                            </TabPanel>
                                                        </TabPanels>
                                                    </Tabs>
                                                </VStack>
                                            </VStack>
                                        }

                                        <Box w={'100vw'} justifyContent={"center"} display={"flex"} flexDirection={'column'} pb={16}
                                             alignItems={'center'} bgGradient="linear(to-b, white 0%, #f8fafc 20%, #f1f8ff 60%, #f0f8fe 100%)">
                                        {/* Three Feature Cards */}
                                        <Container maxW="7xl" pt={10} pb={24}>
                                            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
                                                {/* Find Information */}
                                                <Box
                                                    p={10}
                                                    bg="white"
                                                    borderRadius="2xl"
                                                    boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                    border="1px"
                                                    borderColor="rgba(255, 255, 255, 0.2)"
                                                    position="relative"
                                                    _hover={{
                                                        transform: "translateY(-8px)",
                                                        boxShadow: "0 32px 64px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.9)"
                                                    }}
                                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                    _before={{
                                                        content: '""',
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        height: "4px",
                                                        bg: "linear-gradient(90deg, #2563eb, #3b82f6, #60a5fa)",
                                                        borderTopRadius: "2xl"
                                                    }}
                                                >
                                                    <VStack spacing={6} align="start">
                                                        <VStack spacing={4} align="start">
                                                            <Box
                                                                p={3}
                                                                bg="linear-gradient(135deg, #eff6ff, #dbeafe)"
                                                                borderRadius="xl"
                                                                border="1px"
                                                                borderColor="#bfdbfe"
                                                            >
                                                                <Icon as={FiSearch} color="#2563eb" w={6} h={6} />
                                                            </Box>
                                                            <Heading size="lg" color="#1e293b" fontWeight="bold" textAlign={'left'}>Extract Key Information</Heading>
                                                        </VStack>
                                                        <VStack spacing={4} align="start">
                                                            <Text color="#64748b" lineHeight="1.7" fontSize="md" textAlign={'left'}>
                                                                Efficiently search through all of your documents and files.
                                                            </Text>
                                                            <Text color="#64748b" lineHeight="1.7" fontSize="md" textAlign={'left'}>
                                                                Extract key information & insights and get your questions answered.
                                                            </Text>
                                                        </VStack>
                                                    </VStack>
                                                </Box>

                                                {/* Summarize Content */}
                                                <Box
                                                    p={10}
                                                    bg="white"
                                                    borderRadius="2xl"
                                                    boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                    border="1px"
                                                    borderColor="rgba(255, 255, 255, 0.2)"
                                                    position="relative"
                                                    _hover={{
                                                        transform: "translateY(-8px)",
                                                        boxShadow: "0 32px 64px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.9)"
                                                    }}
                                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                    _before={{
                                                        content: '""',
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        height: "4px",
                                                        bg: "linear-gradient(90deg, #10b981, #34d399, #6ee7b7)",
                                                        borderTopRadius: "2xl"
                                                    }}
                                                >
                                                    <VStack spacing={6} align="start">
                                                        <VStack spacing={4} align="start">
                                                            <Box
                                                                p={3}
                                                                bg="linear-gradient(135deg, #ecfdf5, #d1fae5)"
                                                                borderRadius="xl"
                                                                border="1px"
                                                                borderColor="#a7f3d0"
                                                            >
                                                                <Icon as={FiFileText} color="#10b981" w={6} h={6} />
                                                            </Box>
                                                            <Heading size="lg" color="#1e293b" fontWeight="bold" textAlign={'left'}>
                                                                Summarize and Synthesize
                                                            </Heading>
                                                        </VStack>
                                                        <VStack spacing={4} align="start">
                                                            <Text color="#64748b" lineHeight="1.7" fontSize="md" textAlign={'left'}>
                                                                Accurately summarize any dense report or document.
                                                            </Text>
                                                            <Text color="#64748b" lineHeight="1.7" fontSize="md" textAlign={'left'}>
                                                                Synthesize or find contradictions among multiple files.
                                                            </Text>
                                                        </VStack>
                                                    </VStack>
                                                </Box>

                                                {/* Generate Deliverables */}
                                                <Box
                                                    p={10}
                                                    bg="white"
                                                    borderRadius="2xl"
                                                    boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                    border="1px"
                                                    borderColor="rgba(255, 255, 255, 0.2)"
                                                    position="relative"
                                                    _hover={{
                                                        transform: "translateY(-8px)",
                                                        boxShadow: "0 32px 64px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.9)"
                                                    }}
                                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                    _before={{
                                                        content: '""',
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        height: "4px",
                                                        bg: "linear-gradient(90deg, #8b5cf6, #a78bfa, #c4b5fd)",
                                                        borderTopRadius: "2xl"
                                                    }}
                                                >
                                                    <VStack spacing={6} align="start">
                                                        <VStack spacing={4} align="start">
                                                            <Box
                                                                p={3}
                                                                bg="linear-gradient(135deg, #f5f3ff, #ede9fe)"
                                                                borderRadius="xl"
                                                                border="1px"
                                                                borderColor="#c4b5fd"
                                                            >
                                                                <Icon as={FiEdit3} color="#8b5cf6" w={6} h={6} />
                                                            </Box>
                                                            <Heading size="lg" color="#1e293b" fontWeight="bold" textAlign={'left'}>
                                                                Transcribe Audio/Video
                                                            </Heading>
                                                        </VStack>
                                                        <VStack spacing={4} align="start">
                                                            <Text color="#64748b" lineHeight="1.7" fontSize="md" textAlign={'left'}>
                                                                Get fast transcriptions of your interviews or video/audio files.
                                                            </Text>
                                                            <Text color="#64748b" lineHeight="1.7" fontSize="md" textAlign={'left'}>
                                                                With accurate timestamps and speaker labels.
                                                            </Text>
                                                        </VStack>
                                                    </VStack>
                                                </Box>
                                            </SimpleGrid>
                                        </Container>
                                        
                                       
                                        
                                        <Box width="100vw" justify={'center'} align={'center'}
                                             mt={'1rem'}
                                             display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
                                            <Box width={['100%','89%', '81%', '73%', '64%']}
                                                 borderRadius={!isMobile ? 20 : 0}
                                                 overflow="hidden" position="relative"
                                                 transform="translateY(0)"
                                                 transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                 _hover={{
                                                     transform: "translateY(-8px)",
                                                     boxShadow: `
        0 25px 50px -12px rgba(0, 0, 0, 0.25),
        0 25px 100px -12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.1)
      `
                                                 }}
                                                 boxShadow={`
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04),
      0 0 0 1px rgba(0, 0, 0, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    `}
                                                 _before={{
                                                     content: '""',
                                                     position: 'absolute',
                                                     top: '-2px',
                                                     left: '-2px',
                                                     right: '-2px',
                                                     bottom: '-2px',
                                                     background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 50%, 
        rgba(0, 0, 0, 0.05) 100%
      )`,
                                                     borderRadius: !isMobile ? 22 : 2,
                                                     zIndex: -1,
                                                     opacity: 0.8
                                                 }}
                                                 _after={{
                                                     content: '""',
                                                     position: 'absolute',
                                                     top: 0,
                                                     left: 0,
                                                     right: 0,
                                                     bottom: 0,
                                                     background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        transparent 50%
      )`,
                                                     borderRadius: !isMobile ? 20 : 0,
                                                     pointerEvents: 'none',
                                                     zIndex: 1
                                                 }}>

                                                <LazyLoad height={'auto'} width={'100%'} offset={100}>
                                                    <ReactPlayer url={process.env.PUBLIC_URL + '/new_landing_page_video.m4v'}
                                                                 playing={true} // auto-play on load
                                                                 loop={true} // auto-looping
                                                                 playbackRate={1} // 1.5x speed
                                                                 muted={true}
                                                                 controls={true} // show video controls
                                                                 width={'100%'} // full width
                                                                 height="auto">

                                                    </ReactPlayer>
                                                </LazyLoad>
                                            </Box>
                                            <Text fontSize={'sm'} color={'black'} mt={4} fontWeight="500">
                                                Note: Actual case material isn't shown in the video for security reasons.
                                            </Text>
                                        </Box>

                                        <Box width="100vw" mt={'4.2rem'} justify={'center'} align={'center'} ref={testimonialsRef} mb={'0.5rem'}>
                                            <BigTestimonial/>
                                        </Box>
                                    </Box>
                                        {/*<Box width="100vw" mt={'2.8rem'} justify={'center'} align={'center'} ref={testimonialsRef}>*/}
                                        {/*    <WithSpeechBubbles />*/}
                                        {/*</Box>*/}
                                        <div ref={featuresRef} style={{width: '100vw', display: 'flex',
                                            justifyContent:'center', marginTop: '2.5rem', flexDirection: 'column', alignItems: 'center'}}>
                                            <Heading size="2xl" textAlign="center" color="#1e293b" fontWeight="bold" mb={10} mt={4}>
                                                Features
                                            </Heading>
                                            <TwoColumnLayout theFileInput={fileInput} onOpenSignUpScreen1={onOpenSignUpScreen1}
                                                             urlInput={urlInput} setUrlInput={setUrlInput} handleSubmit={handleSubmit}
                                                             currentPlaceholder={currentPlaceholder} fade={fade}/>
                                        </div>
                                        <Box width="100vw" mt={'3.5rem'} justify={'center'} align={'center'}>
                                            <FAQ2/>
                                        </Box>
                                        {/*<Box width="100vw" mt={'3.5rem'} justify={'center'} align={'center'} ref={testimonialsRef}>*/}
                                        {/*    <BigTestimonial/>*/}
                                        {/*</Box>*/}
                                    </Flex>
                                </Stack>

                                {/* Bottom CTA - Dark Blue */}
                                <Box bg="#1e293b" py={16} width={'100vw'} ml={-5}>
                                    <Container maxW="4xl" textAlign="center">
                                        <VStack spacing={6}>
                                            <Text color="#94a3b8" textTransform="uppercase" letterSpacing="wide" fontSize="sm" fontWeight="medium">
                                                IMPROVE YOUR PRODUCTIVITY
                                            </Text>
                                            <Heading size="2xl" color="white" fontWeight="bold">
                                                Save 9+ Hours/Week
                                            </Heading>
                                            <Text color="lightgray" fontSize="lg" maxW="2xl" fontWeight={500}>
                                                29% of PI's in a recent survey reported that Justify saves them 9-14 hours every week.
                                            </Text>
                                            <Button
                                                borderRadius={16}
                                                px={isMobile ? 6 : 7}
                                                py={isMobile ? 6 : 7}
                                                fontSize={isMobile ? 18 : 22}
                                                colorScheme={'orange'}
                                                bgGradient="linear(to-r, orange.400, orange.500)"
                                                _hover={{
                                                    bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                    boxShadow: 'lg' // Adds a slight shadow on hover
                                                }}
                                                onClick={() => {
                                                    if (auth.isLoggedIn) {
                                                        fileInput.current.click();
                                                    } else {
                                                        onOpenSignUpScreen1();
                                                    }
                                                }}>
                                                Try for Free
                                            </Button>
                                            {/*<Button*/}
                                            {/*    bg="white"*/}
                                            {/*    color="#1e293b"*/}
                                            {/*    size="lg"*/}
                                            {/*    px={8}*/}
                                            {/*    py={6}*/}
                                            {/*    fontSize="lg"*/}
                                            {/*    borderRadius="lg"*/}
                                            {/*    _hover={{ bg: "#f8fafc" }}*/}
                                            {/*    fontWeight="600"*/}
                                            {/*>*/}
                                            {/*    Start for Free*/}
                                            {/*</Button>*/}
                                        </VStack>
                                    </Container>
                                </Box>
                            </Container>
                        ) : (
                            renderTabContent()
                        )
                    }
                </VStack>
            </FullScreenTemplateHomePage>
            <Box height={"4rem"}/>
            <LargeWithNewsletter color={"white"} />
            <SignUpScreen1 isOpenSignUpScreen1={isOpenSignUpScreen1} onCloseSignUpScreen1={onCloseSignUpScreen1} onOpenSignInScreen1={onOpenSignInScreen1}/>
            <SignInScreen1 isOpenSignInScreen1={isOpenSignInScreen1} onCloseSignInScreen1={onCloseSignInScreen1} onOpenSignUpScreen1={onOpenSignUpScreen1}/>
            <ScanModal1 isOpenScanModal1={isOpenScanModal1} onCloseScanModal1={onCloseScanModal1} onOpenScanModal1={onOpenScanModal1}/>
            <ScanModalIntro1 isOpenScanModalIntro1={isOpenScanModalIntro1} onCloseScanModalIntro1={onCloseScanModalIntro1}
                             onOpenScanModalIntro1={onOpenScanModalIntro1}/>
            <PricingScreen isOpenPricingScreen={isOpenPricingScreen}
                           onClosePricingScreen={onClosePricingScreen}
                           onOpenPricingScreen={onOpenPricingScreen}/>
        </div>
    );
};

export default NewUnifiedHomePage;







